import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import RightSidebar from "./RightSidebar";
import BottomBar from "./BottomBar";
import config from "./config";
import { sharedData } from "../sharedData/sharedData";
import { utilityService } from "../requests/utilityService";
import { useValidateEdd } from "../validations/validationHooks/useValidationEdd";
import FloatingQueryCenter from "./FloatingQueryCenter";
import StepTabs from "./StepTabs";
import "./TransactionDetail.css";
import LoaderModal from './Loader';
import ConfirmationModal from "./ui/ConfirmationModal";
import { EDDForm } from "./forms/EDD/edd"
import { userSession } from "../observers/userObserver";
import ViewModeBanner from "./ui/ViewModeBanner";
import { reloadAfterValidate } from "../utils/reloadAfterValidate";
import { useEntityId } from "../hooks/useEntityId";
import { clientCoutnerpartyService } from "../requests/clientCounterpartyService";
import { ClientCounterpartyFactory } from "../factory/clientCoutnerpartyFactory";
const EDD = () => {


  const entityId = useEntityId();
  const requestId = useMemo(() => sharedData.get("requestId"), []);
const [modalOpen, setModalOpen] = useState(false);
const [modalHeading, setModalHeading] = useState("");
 const showLoader = (message) => {
  setLoadingMessage(message);
  setIsLoading(true);
};

const hideLoader = () => {
  setIsLoading(false);
  setLoadingMessage('');
};
  const [isLoading, setIsLoading] = useState(false);
const [loadingMessage, setLoadingMessage] = useState('');


  const location = useLocation();
  // const { requestId, transactionId, status, entityId, propertyId } = location.state || {};
  const [selectedOption, setSelectedOption] = useState("");
  const [SellerSelectedOption, setSellerSelectedOption]= useState("")
  const [searchParams, setSearchParams] = useSearchParams();

  const [otherValue, setOtherValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [SellerShowDropdown, setSellerShowDropdown]= useState(false);
  const [showTextarea, setShowTextarea] = useState(false);
  const [hasMortgage, setHasMortgage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(
    searchParams.get("readonly") === "true" ||
    searchParams.get("view") === "true"
  );
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isEddCompleted, setIsEddCompleted] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {errors, validateEdd} = useValidateEdd();
 
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const handleSelection = (event) => {
    setShowTextarea(event.target.value === "Yes");
  };
  
  const checkIsReadOnly = (status = undefined) => {
    const isEditMode = searchParams.get("edit") === "true";
    const isTransactionCompleted = status === "Validated";
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";

    setIsEddCompleted(isTransactionCompleted)
    return isTransactionCompleted || isReadOnlyFromURL || isViewMode;
  };

  const handleValidate =async () => {
    console.log("Validate clicked");
    // Validating before clientType is known would apply the wrong schema and lock the record.
    if (!isClientTypeResolved) {
      setModalMessage("Still loading client details. Please try again in a moment.");
      setModalOpen(true);
      return;
    }
    // Validate what is actually on screen, not the localStorage snapshot.
    const updatedFormData = { ...formData };
    console.log('updated form',updatedFormData)
    const errors = validateEdd(updatedFormData, clientType);
    // const errors = validateEdd(clientType,updatedFormData);
    console.log("Validation Errors: ", errors);
    if (errors) {
      // TODO: Show errors in modal
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>
            Validation Result
          </h2>
          <strong>Please fill in the following required fields:</strong>
          <br />
          <div style={{ "maxHeight": "200px", "overflow": "auto" }}>
          {Object.keys(errors).map((field) => (
            <div key={field}>
              <ul>
                {errors[field].map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          ))}
          </div>
        </>
      )
     
      // setIsEmailModalOpen(true);
      setModalOpen(true);
      return
     
    }
    await SaveEdd(true);
    setIsReadOnly(true); // ✅ this should now work properly
    checkIsReadOnly("Validated");
    // Keep the local status in step so the banner names the real reason immediately,
    // without waiting for the reload below to re-fetch it.
    setFormData((prev) => ({ ...prev, status: "Validated" }));
    reloadAfterValidate();

    return;
  };

  const handleNext = () => {
    const userType = userSession.getUserType()?.toLowerCase();
    const isBypassUser = userType === "mlno" || userType === "cod";
    if (!isBypassUser && !checkStatus) {
      setModalMessage("Please validate Enhanced Due Diligence before proceeding to Final Review.");
      setModalOpen(true);
      return;
    }
    navigate(`/FinalReview?${searchParams.toString()}`);
  };
  

  // Keys must match the /save_edd + /get_edd contract exactly. Anything the form invents a
  // name for is dropped on save and comes back blank after Validate & Lock.
  const [formData, setFormData] = useState({
    PurchaserwealthSource: "",
    PurchaserWealthSourceOther: "",
    PurchaserTimeframeWealthAccumlated: "",
    PurchaserHowPossessTheirOverallAssests: "",
    PurchaserIsRelationshipNew: "",
    PurchaserClientKnownDuration: "",
    PurchaserStepsTakenToverifyWealth: "",
    SourceOfFundForTransactionGenerated: "",
    SourceBankName: "",
    SourceAccountNumber: "",
    PurchaserFundSourceVerifiedIndependently: "",
    PurchaseFundVerifiedDetail: "",
    SellerWealthSource: "",
    SellerWealthSourceOther: "",
    SellerTimeframeWealthAccumlated: "",
    SellerHowPossessTheirOverallAssests: "",
    SellerIsRelationshipNew: "",
    SellerClientKnownDuration: "",
    SellerStepsTakenToverifyWealth: "",
    SellerBussinessNature: "",
    SellerFundSourceVerifiedIndependently: "",
    MortgageOnProperty: "",
    MortgageBankName: "",
    DestinationBankName: "",
    DestinationAccountNumber: "",
    FurthurInformation: "",
    status:""
  });

  // Single source of truth for the lock: the status on screen. Reading the
  // localStorage copy left a validated page rendering unlocked until a reload.
  const checkStatus = formData.status === "Validated";

  useEffect(() => {
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";
    setIsReadOnly(isReadOnlyFromURL || isViewMode || checkStatus);
  }, [checkStatus, searchParams]);

  // ✅ Load data from localStorage on component mount
  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("EDDFormData"));
    if (savedData) {
      setFormData(savedData);
      const isReadOnly = checkIsReadOnly(savedData.status);
      setIsReadOnly(isReadOnly);
    }
  }, []);







   const handleSearch = async () => {
  const clientFormData = JSON.parse(localStorage.getItem("clientFormData") || "{}");

  const entityname = clientFormData.companyName || "";
  const country = clientFormData.countryOfIncorporation || "";
  const companyType = clientFormData.companyType || "LTD";
  const dateRange = 10;

  console.log("Entity Name:", entityname);

  if (!entityname || !country || !companyType) {
    setModalMessage("Missing required data. Please ensure Client/Counterparty details are saved.");
    setModalOpen(true);
    return;
  }

  const payload = {
    name: entityname,
    country: country,
    entityType: companyType,
    dateRange: dateRange,
  };

  try {
    const response = await fetch(`${config["backend-url"]}/Financial_fnds`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userSession.getToken()}`,
      },
      body: JSON.stringify(payload),
    });

    // Optional: debug response
    console.log("Adverse media search triggered. Status:", response.status);

  } catch (error) {
    console.error("Error calling adverse media search API:", error);
  }
};



  
  const SaveEdd = async (isValidated = undefined) => {
    console.log("edd");
    let newFormData = formData;
  
    if (isValidated) {
      newFormData = {
        ...formData,
        status: "Validated",
      };
      setFormData(newFormData);
      localStorage.setItem("EDDFormData", JSON.stringify(newFormData));
    }
  
    setHasUnsavedChanges(false);
    setLoading(true);
    console.log("entity", entityId);
  
    try {
      const payload = {
        ...newFormData,
        entityId: entityId,
      };
  
      const response = await fetch(`${config["backend-url"]}/save_edd`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${userSession.getToken()}`,
        },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        setModalMessage("Enhanced Due Diligence saved successfully!");
        setModalOpen(true);
      } else {
        const error = await response.json();
        setModalMessage(error.message);
        setModalOpen(true);
      }
    } catch (error) {
      console.error('Error saving data:', error);
      setModalMessage(error.message || "Error saving data");
      setModalOpen(true);
    } finally {
      setLoading(false);
      const isReadOnly = checkIsReadOnly(newFormData.status);
      setIsReadOnly(isReadOnly);
    }
  };
  




  // clientType decides which half of the form is rendered AND which schema validates it.
  // It used to be read straight from localStorage.clientFormData, which the dashboard wipes
  // (resetFormCache) and only the Client/Counterparty page refills. Reaching EDD without
  // passing through that page therefore left it null, which rendered both halves. Fall back
  // to the server so the page never has to guess, and hold the form back until it knows —
  // rendering the wrong questions is worse than rendering them a moment later.
  const [clientType, setClientType] = useState(null);
  const [isClientTypeResolved, setIsClientTypeResolved] = useState(false);

  useEffect(() => {
    let cached = {};
    try {
      cached = JSON.parse(localStorage.getItem("clientFormData")) || {};
    } catch (error) {
      console.error("Error parsing clientFormData:", error);
    }

    if (cached.clientType) {
      setClientType(cached.clientType);
      setIsClientTypeResolved(true);
      return;
    }

    // Nothing to fetch without an id, so resolve as unknown rather than hanging behind the
    // loader. useEntityId re-runs this if an id lands later. Unknown is now safe: validateEdd
    // requires both halves when clientType is unknown, matching what the form renders.
    if (!entityId) {
      setIsClientTypeResolved(true);
      return;
    }

    let cancelled = false;
    (async () => {
      const entityDetail = await clientCoutnerpartyService.fetchQuickEntityDetailsByEntityId(entityId);
      if (cancelled) return;

      if (entityDetail?.details) {
        const clientData = ClientCounterpartyFactory(entityId, entityDetail.details);
        // Refill the cache the dashboard wiped. handleSearch below reads companyName /
        // countryOfIncorporation from it, and failed the same way for the same reason.
        localStorage.setItem("clientFormData", JSON.stringify(clientData));
        setClientType(clientData.clientType || null);
      }
      setIsClientTypeResolved(true);
    })();

    return () => {
      cancelled = true;
    };
  }, [entityId]);

  useEffect(() => {
    // Without this the request went out with no entityId, /get_edd answered 400 "Missing
    // entityId", and the branch below quietly skipped — leaving a blank form and no retry.
    if (!entityId) return;

    const fetchEdd = async () => {
      try {
        const response = await fetch(`${config["backend-url"]}/get_edd`, {
          method: "POST",
          headers: { "Content-Type": "application/json",
            "Authorization": `Bearer ${userSession.getToken()}`
           }
          ,
          body: JSON.stringify({ entityId })
        });
        const data = await response.json();
        if (response.ok && data.edd_data) {

          setFormData(data.edd_data);
          // Cache it as well. Nothing else writes EDDFormData, so without this the page had
          // no data to fall back on and depended entirely on this fetch succeeding.
          localStorage.setItem("EDDFormData", JSON.stringify(data.edd_data));
          const isReadOnly = checkIsReadOnly(data.edd_data.status);
      setIsReadOnly(isReadOnly);

        } else if (response.status !== 404) {
          // 404 is normal — a request with no EDD record yet. Anything else is a real failure
          // and must not disappear behind an empty form.
          console.error("Failed to fetch EDD data:", response.status, data);
        }
      } catch (error) {
        console.error("Failed to fetch EDD data:", error);
      }
    };
    fetchEdd();
  }, [entityId]);


  const sendMail = async (userType) => {
    showLoader('Sending email, please wait...');
    try {
      const payload = {
        requestId: requestId,
        userType: userType
      };
      
  
      const data = await utilityService.sendMail(payload); // await is optional if you don't need response

      console.log("✅ Email sent", data);
      setModalMessage("Email sent successfully!")
      // setIsEmailModalOpen(true)
      setModalOpen(true);
          } catch (error) {
      console.error("❌ Failed to send email:", error);
      setModalMessage("Failed to send email")
      // setIsEmailModalOpen(true)
      setModalOpen(true);
   
    }
    hideLoader();
  };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
  
  
    // ✅ Handle value update (for checkboxes and text fields)
    const updatedValue = type === "checkbox" ? checked : value;
  
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        [name]: updatedValue || "", // If empty, store as an empty string
      };
  
     
  
      // ✅ Save full form data to localStorage
      localStorage.setItem("EDDFormData", JSON.stringify(updatedFormData));
  
      // ✅ Handle conditional rendering (for specific fields)
      if (name === "PurchaserIsRelationshipNew") {
        setShowDropdown(updatedValue === "No");
      }
      if (name === "SellerIsRelationshipNew") {
        setSellerShowDropdown(updatedValue === "No");
      }
      if (name === "MortgageOnProperty") {
        setHasMortgage(updatedValue === "Yes");
      }
      if (name === "PurchaserFundSourceVerifiedIndependently") {
        setShowTextarea(updatedValue === "Yes");
      }
  
      return updatedFormData;
    });
  };
  
 const handleSubmit = (event) => {
    event.preventDefault();
    // Your logic here
  };


  return (
    <>
    
    <div className="transaction-detail" >
      {/* Main Form */}
      <StepTabs hasUnsavedChanges={hasUnsavedChanges} searchParams={searchParams}/>
      <ViewModeBanner
        isReadOnly={isReadOnly}
        status={formData?.status}
      />
      <div className="form-section">
      {isClientTypeResolved && (
        <EDDForm
              handleSearch={handleSearch}
             formData={formData}
             handleChange={handleChange}
             isReadOnly={isReadOnly}
             handleSubmit={handleSubmit}
             sendMail={sendMail}
  clientType={clientType}
              />
      )}
      <RightSidebar 
    eddFormData={formData}
    />
    </div>

     
    </div>
    
    <BottomBar 
          buttons={[
            { label: "Save", onClick: SaveEdd ,skipConfirmation: true , disabled: checkStatus},
            { label: "Validate & Lock", onClick: handleValidate , disabled: checkStatus },
            {
      label: "Back",
      onClick: () => navigate(`/corporate-structure?${searchParams.toString()}`),
      style: {},
      title: "Go back",
      disabled: false,
    },
            { label: "Next", onClick: handleNext }
          ]}
        />
             {/* {isEmailModalOpen && (
      <div className="modal" style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1
      }}>
        <div className="modal-content" style={{
    background: "white",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center"
  }}> 
 
          <p style={{textAlign:"left"}}>{modalMessage}</p>
          <button onClick={() => setIsEmailModalOpen(false)} style={{
              marginTop: "10px",
              padding: "8px 16px",
              border: "none",
              background: "#07b1b0",
              color: "white",
              borderRadius: "4px",
              cursor: "pointer",
            }}>Close</button>
        </div>
      </div>
    )} */}
      <LoaderModal isOpen={isLoading || !isClientTypeResolved} message={loadingMessage || "Loading..."} />
       <ConfirmationModal
              isOpen={modalOpen}
              heading= {modalHeading}
              message={modalMessage}
              onClose={() => setModalOpen(false)}
            />
    <FloatingQueryCenter />
     </>
  );
};



export default EDD;
